import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import { Chrono } from "react-chrono";

const experienceItems = [
  {
    title: "September 2024 - Present",
    cardTitle: "Data Engineer Intern",
    cardSubtitle: "zeb",
    cardDetailedText:
      "Currently working as a Data Engineer Intern at ZEB, contributing to data pipelines and architecture optimization. I am involved in developing robust data processing workflows and ensuring smooth data integration from various sources to enhance the overall data management system. My responsibilities include ensuring data quality, assisting with large-scale data manipulation tasks, and collaborating with cross-functional teams to deliver actionable data-driven insights for business strategies.",
  },
  {
    title: "October 2023 - July 2024",
    cardTitle: "Junior Data Scientist",
    cardSubtitle: "Zummit Infolabs",
    cardDetailedText:
      "Actively participate in projects related to emerging technologies, contributing expertise in Machine Learning (ML) and Deep Learning (DL) methodologies. Collaborate with cross-functional teams to understand project requirements and develop innovative solutions utilizing ML and DL techniques. Conduct in-depth research on the latest advancements in ML and DL. Explore novel algorithms, frameworks, and tools to enhance the organization's capabilities in leveraging these technologies effectively.",
  },
  {
    title: "June 2023 - September 2023",
    cardTitle: "Intern",
    cardSubtitle: "Cisco Virtual Internship Program",
    cardDetailedText:
      "Conducted comprehensive analysis of the College Lab Block connections, including mapping out the network architecture, identifying potential vulnerabilities, and assessing overall security posture. Proposed and implemented proactive measures to mitigate identified risks and strengthen network security, ensuring the integrity and confidentiality of college network resources.",
  },
  {
    title: "May 2023",
    cardTitle: "Deep Learning Trainee",
    cardSubtitle: "MedTourEasy",
    cardDetailedText:
      "Implemented image classification algorithms to categorize images into predefined classes or labels. Fine-tuned pre-trained models or developed custom architectures to achieve high accuracy in classifying images across different categories or domains. Developed object detection models to identify and localize objects within images or video streams. Utilized popular architectures like YOLO and Faster R-CNN to detect objects with precision and efficiency, contributing to tasks such as surveillance, autonomous vehicles, or medical imaging.",
  },
  {
    title: "March 2023 - May 2023",
    cardTitle: "Data Scientist Intern",
    cardSubtitle: "Technocolabs Softwares",
    cardDetailedText:
      "Extracted actionable insights from the analysis, including factors influencing loan default rates, risk mitigation strategies, and opportunities for portfolio optimization in P2P lending. Completed an end-to-end data analysis project on P2P lending, demonstrating proficiency in all stages of the data analysis lifecycle from data acquisition to insights generation.",
  },
  {
    title: "January 2023 - February 2023",
    cardTitle: "ML-IoT Trainee",
    cardSubtitle: "National Institute of Technology Karnataka (NITK)",
    cardDetailedText:
      "Worked as a Machine Learning and IoT Trainee at NITK, where I focused on developing machine learning models for IoT-based applications. My tasks included implementing predictive models for real-time sensor data analysis and optimization of IoT systems using machine learning algorithms. I collaborated with faculty and other trainees to work on research projects that explored the integration of machine learning in IoT environments, providing valuable insights into smart device communication and automation.",
  },
];

function Experience() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading" style={{ color: "violet" }}>
          My Internship <strong>Experiences</strong>
        </h1>
        <p style={{ color: "white" }}>Here are a few works I've done </p>
        <Chrono
          items={experienceItems}
          mode="VERTICAL_ALTERNATING"
          slideShow
          slideItemDuration={4000}
          allowDynamicUpdate={false}
          allowDynamicResize={false}
          hideControls={true} // Hide the control buttons
          disableNavOnKey={true} // Disable navigation using arrow keys
          theme={{
            primary: "#c770f0", // Set the primary color to the desired color
            secondary: "white", // Set the secondary color to white
            cardBgColor: "#f9f9f9", // Card background color
            cardForeColor: "#333", // Card text color
            cardBorderColor: "#ccc", // Card border color
          }}
          // Customizing the Chrono component's title and cardTitle colors to violet
          customContent={{
            cardTitle: { style: { color: "violet" } },
            title: { style: { color: "violet" } },
          }}
        />
      </Container>
    </Container>
  );
}

export default Experience;
